var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-footer',{attrs:{"dark":"","padless":"","app":"","inset":""}},[_c('v-card',{staticClass:"flex",attrs:{"flat":"","tile":"","color":"white","elevation":10}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }